import { NextRequest } from "next/server"

const extractIPAddress = (address: string | null | undefined): string => {
  if (address?.startsWith("::ffff:")) {
    return address.slice(7)
  }
  return address || ""
}

// 兼容 Next.js 15 的 IP 地址提取函数
export const getIPFromNextRequest = (request: NextRequest): string => {
  // 从 headers 中获取 IP 地址
  const forwardedFor = request.headers.get("x-forwarded-for")
  const realIP = request.headers.get("x-real-ip")
  const cfConnectingIP = request.headers.get("cf-connecting-ip") // Cloudflare

  let address: string | null = null

  // 优先级：cf-connecting-ip > x-real-ip > x-forwarded-for
  if (cfConnectingIP) {
    address = cfConnectingIP
  } else if (realIP) {
    address = realIP
  } else if (forwardedFor) {
    // x-forwarded-for 可能包含多个 IP，取第一个
    address = forwardedFor?.split(",")[0]?.trim() || null
  }

  return extractIPAddress(address)
}
export const getBrowserInfo = (userAgent: string) => {
  // 浏览器类型及版本
  const agent = userAgent ? userAgent.toLowerCase() : ""
  const regStrFF = /firefox\/[\d.]+/gi
  const regStrChrome = /chrome\/[\d.]+/gi
  const regStr360se = /360se\/[\d.]+/gi
  const regStrSougou = /metasr\s[\d.]+/gi
  const regStrQQ = /qqbrowser\/[\d.]+/gi
  const regStrSafari = /safari\/[\d.]+/gi

  // 360
  if (agent.indexOf("360se") > 0) {
    return agent.match(regStr360se) ? agent.match(regStr360se)![0] : "360se"
  }

  // 搜狗
  if (agent.indexOf("metasr") > 0) {
    return agent.match(regStrSougou) ? agent.match(regStrSougou)![0].replace("metasr", "sougou") : "sougou"
  }

  // qq浏览器
  if (agent.indexOf("qqbrowser") > 0) {
    return agent.match(regStrQQ) ? agent.match(regStrQQ)![0] : "qqbrowser"
  }

  // firefox
  if (agent.indexOf("firefox") > 0) {
    return agent.match(regStrFF) ? agent.match(regStrFF)![0] : "firefox"
  }

  // Safari
  if (agent.indexOf("safari") > 0 && !agent.includes("chrome")) {
    return agent.match(regStrSafari) ? agent.match(regStrSafari)![0] : "safari"
  }

  // Chrome
  if (agent.indexOf("chrome") > 0 && !agent.includes("360se") && !agent.includes("metasr")) {
    return agent.match(regStrChrome) ? agent.match(regStrChrome)![0] : "chrome"
  }

  const isIE = agent.includes("compatible") && agent.includes("msie") // 判断是否IE<11浏览器
  // const _isEdge = agent.includes('edge') && !isIE; // 判断是否IE的Edge浏览器
  const isIE11 = agent.includes("trident") && agent.includes("rv:11.0")
  if (isIE) {
    const reIE = /msie (\d+\.\d+);/
    reIE.test(agent)
    const fIEVersion = Number.parseFloat(RegExp.$1)
    if (fIEVersion === 7) {
      return "IE/7"
    }
    if (fIEVersion === 8) {
      return "IE/8"
    }
    if (fIEVersion === 9) {
      return "IE/9"
    }
    if (fIEVersion === 10) {
      return "IE/10"
    }
  }
  // isIE end
  if (isIE11) {
    return "IE/11"
  }

  return ""
}

export const isMobileWeb = (userAgent: string) => {
  if (
    userAgent.match(
      /(phone|iPhone|iPod|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return true
  }

  return false
}
